export default class Auth0Manager {
  static auth0Manager
  static listeners = new Set()

  static setAuth0Manager(auth0) {
    this.auth0Manager = auth0
    this.listeners.forEach(listener => listener(auth0))
  }

  static subscribe(listener) {
    this.listeners.add(listener)
    listener(this.auth0Manager)
    return () => this.listeners.delete(listener)
  }

  static getAccessToken() {
    return this.auth0Manager?.getAccessTokenSilently()
  }

  static getAuth0Instance() {
    return this.auth0Manager
  }
}
